import {createEntityAdapter} from '@reduxjs/toolkit'
import { IJuridicalPerson } from '../../types'

export const juridicalPersonsAdapter = createEntityAdapter<IJuridicalPerson>()